import {useEffect} from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Footer from './Footer'
import Navbar from './Navbar'
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";

const Layout = ({ children }) => {
    const navigate = useNavigate();



    useEffect(()=>{
        const token = localStorage.token;
        if(token === undefined || null){
           return navigate('/login')
        }
    },[])
    return (
        <>
            <Navbar />
            <div className='container'>
                {children}
            </div>
            {/* <Footer/> */}
        </>

    )
}

export default Layout